module.exports = __webpack_public_path__ + "static/media/SPMS_IC_MobileLogo.397c3447.png";